import type { Hero, Point, Scene, Token } from "../types";
import { clampHeroRingScale } from "./hero-presentation";

export type TokenPositionSnapshot = Record<string, Point>;

export function captureTokenPositions(tokens: Token[]): TokenPositionSnapshot {
  return Object.fromEntries(tokens.map((token) => [token.id, { ...token.position }]));
}

export function countRestorableTokens(tokens: Token[], snapshot?: TokenPositionSnapshot): number {
  if (!snapshot) return 0;
  return tokens.filter((token) => Boolean(snapshot[token.id])).length;
}

export function restoreTokenPositions(tokens: Token[], snapshot: TokenPositionSnapshot): Token[] {
  return tokens.map((token) => snapshot[token.id] ? { ...token, position: { ...snapshot[token.id] } } : token);
}

export function syncHeroTokens(scenes: Scene[], hero: Hero, nextPreset: Pick<Hero, "name" | "color" | "ringScale">): Scene[] {
  const updatedAt = Date.now();
  return scenes.map((scene) => {
    if (scene.campaignId !== hero.campaignId) return scene;
    let changed = false;
    const tokens = scene.tokens.map((token) => {
      const linked = token.heroId === hero.id;
      const legacyMatch = !token.heroId && token.type === "player" && token.name === hero.name && token.color === hero.color;
      if (!linked && !legacyMatch) return token;
      const heroRingScale = clampHeroRingScale(nextPreset.ringScale);
      if (linked && token.name === nextPreset.name && token.color === nextPreset.color && token.heroRingScale === heroRingScale) return token;
      changed = true;
      return { ...token, heroId: hero.id, name: nextPreset.name, color: nextPreset.color, heroRingScale };
    });
    return changed ? { ...scene, tokens, updatedAt } : scene;
  });
}
